import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";

class RequestDialog extends Component {
    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.dataItem.beginAdd(key));
        } catch (e) {
            console.error(e);
        }
    }

    onClose = () => {
        this.props.dispatch(this.props.dataItem.cancelAdd())
            .then(() => {
                if (!this.props.dataItem.isError) {
                    if (this.props.onClose)
                        this.props.onClose();
                }
            })
    }

    onSaveRowAdd = (e) => {
        e.preventDefault();

        return this.props.dispatch(this.props.dataItem.saveAdd(this.props.dataItem.rowInEditIndex))
            .then(() => {
                if (!this.props.dataItem.isError) {
                    if (this.props.onClose)
                        this.props.onClose();
                }
            })
            .catch(error => this.props.dispatch(errorRaised(error)));
    }

    onCancelAdd = (e) => {
        this.onClose();
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead"
                        onClick={this.onSaveRowAdd}>{i18next.t('Save')}
                </button>
                <button className="btn btn-regular"
                        onClick={this.onCancelAdd}>{i18next.t('Cancel')}
                </button>
            </div>
        </div>)
    }

    render() {
        return (
            <PopupWrapper popupVisible={true} title={i18next.t("NewRequest")} onClose={this.onClose}
                          renderButtons={this.renderButtons} maxWidthBody='500px' minHeightBody='200px'>
                <ComplexParam dataItem={this.props.dataItem} rowIndex={this.props.dataItem.rowInEditIndex}
                              showApplyButton={false} showSearchBar={false}
                              renderParams={paramRender}
                />
            </PopupWrapper>
        )
    }
}

RequestDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    onClose: PropTypes.func
}

RequestDialog.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
    }
}

export default connect(mapStateToProps)(RequestDialog)